import { IFormViewForm } from 'components/FormView';

const Images: IFormViewForm = {
  id: 'Images',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: 1,
      position: {
        row: 1,
        col: 1,
        colspan: 3
      },
      type: 'PAPER_CONTAINER',
      visible: true,
      props: {
        fullWidth: true
      },
      children: [{
        type: 'IMAGE_GRID',
        name: 'ImageGrid',
        props: {
          name: 'ImageGrid',
          variant: 'InventoryEnquiryImages'
        }
      }]
    }
  ]
};
export default Images;
